import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: "share-app-64309",
  storageBucket: "share-app-64309.appspot.com",
  messagingSenderId: "647191503919",
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: "G-SNTXH0QPZ8",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const authentication = getAuth(app);
